import React from 'react';
import Layout from '../../shared/app';

const App = () => <Layout />;

export default App;
